import React, { useEffect, useMemo, useRef } from 'react';
import { TopicLayers as MapTopicLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';
import { useTracking } from '../../utils/tracking/TrackingContext';

const TopicLayers = () => {
  const topicSubLayerSetting = useAppState((state) => state.topicSubLayerSetting);
  const errorLayers = useAppState((state) => state.errorLayers);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const newAddedTopicLayer = useAppState((state) => state.newAddedTopicLayer);
  const { Tracking } = useTracking();

  const errorLayersString = useMemo(
    () => JSON.stringify(errorLayers.sort()),
    [errorLayers],
  );
  const prevErrorLayers = useRef<string[]>(errorLayers);

  useEffect(() => {
    const newErrorLayers = errorLayers.filter(
      (element) => !prevErrorLayers.current.includes(element),
    );
    newErrorLayers.forEach((id) => {
      if (selectedTopicLayers.includes(id)) {
        Tracking.Error.topicLoadingError(id);
      }
    });
    prevErrorLayers.current = errorLayers;
  }, [errorLayersString]);

  useEffect(() => {
    if (
      newAddedTopicLayer &&
      selectedTopicLayers.includes(newAddedTopicLayer) &&
      errorLayers.includes(newAddedTopicLayer)
    ) {
      Tracking.Error.topicLoadingError(newAddedTopicLayer);
    }
  }, [selectedTopicLayers]);

  const visibleSubLayers = Object.fromEntries(
    Object.entries(topicSubLayerSetting).map(([topicId, setting]) => [
      topicId,
      setting.filter((subLayer) => subLayer.isEnabled).map((subLayer) => subLayer.id),
    ]),
  );

  return <MapTopicLayers visibleSubLayers={visibleSubLayers} />;
};

export default TopicLayers;
